import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Field } from 'redux-form';

import RadioField from '../fields/RadioField';
import Heading from '../elements/PageHeading';
import renderError from '../elements/renderError';

const Form = styled.div`
  margin-top: 50px;
  text-align: center;
`;

const OrganizationPage = organizations => ({ t, handleSubmit }) => (
  <React.Fragment>
    <Heading text={t('device_organization.title')} />
    <Form onSubmit={handleSubmit}>
      <fieldset>
        {organizations.map(organization => (
          <RadioField
            key={organization.Id}
            name="Organization"
            type="radio"
            component="input"
            value={organization.Id}
            label={organization.Name}
          />
        ))}
        <Field name="Organization" component={renderError} />
      </fieldset>
    </Form>
  </React.Fragment>
);

export default organizations => translate()(OrganizationPage(organizations));
